// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IStatisticInfoDto
 */
export interface IStatisticInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IStatisticInfoDto
     */
    category_type?: IStatisticInfoDtoCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IStatisticInfoDto
     */
    percent?: number;
    /**
     * 
     * @type {number}
     * @memberof IStatisticInfoDto
     */
    amount?: number;
}

/**
* @export
* @enum {string}
*/
export enum IStatisticInfoDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the IStatisticInfoDto interface.
 */
export function instanceOfIStatisticInfoDto(value: object): value is IStatisticInfoDto {
    return true;
}

export function IStatisticInfoDtoFromJSON(json: any): IStatisticInfoDto {
    return IStatisticInfoDtoFromJSONTyped(json, false);
}

export function IStatisticInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IStatisticInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'percent': json['percent'] == null ? undefined : json['percent'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function IStatisticInfoDtoToJSON(json: any): IStatisticInfoDto {
    return IStatisticInfoDtoToJSONTyped(json, false);
}

export function IStatisticInfoDtoToJSONTyped(value?: IStatisticInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category_type': value['category_type'],
        'percent': value['percent'],
        'amount': value['amount'],
    };
}

